import { isArray } from './array';
import { isObject } from './object';
export function isRecord(value) {
    return isObject(value) && !isArray(value);
}
export function assertisRecord(value) {
    if (!isRecord(value)) {
        throw TypeError(`Value is not of type Record<string | number | symbol, unknown>`);
    }
}
export function getRecordKeys(record) {
    return Object.keys(record);
}
//# sourceMappingURL=record.js.map